/*
 * @Overview:   risk-assessment
 * @Author:     Zi_Jun
 * @Email:      zijun2030@163.com
 * @Date:       2020/7/14 11:52
 * @Mark:       //
 */

import fetch from "@/utils/request";


export default {
  postRiskAssessment(data?: object): any {
    return fetch({
      url: "/php/api/account/risk/assessment",
      method: "post",
      data
    });
  },

  getRiskAssessment(data?: object): any {
    return fetch({
      url: "/php/api/account/risk",
      method: "get",
      data
    });
  }
};
